// Libs

// Utils
import { useOnChangeCommitted } from "src/design-system/core/hooks/useOnChangeCommitted";

// Components
import React from "react";
import { isReactElement } from "src/design-system/core/utils";
import { FieldHoc } from "./Field";

export interface InputOnChangeCommitted extends React.PropsWithChildren<unknown> {
    /**
     * Change handler
     */
    onChangeCurrent?: React.ChangeEventHandler<HTMLInputElement>;
    /**
     * Change handler
     */
    onChangeCommitted: React.ChangeEventHandler<HTMLInputElement>;
    /**
     * Value
     */
    value: any;
}

export function InputOnChangeCommitted({
    children,
    value: valueProp,
    onChangeCurrent,
    onChangeCommitted,
}: InputOnChangeCommitted): JSX.Element {
    const { currentValue, onChange } = useOnChangeCommitted({
        value: valueProp,
        onChange: onChangeCurrent,
    });

    const content =
        isReactElement(children) &&
        React.cloneElement(children, {
            value: currentValue,
            onChangeCommitted,
            onChange,
        });

    return content;
}

export const InputOnChangeCommittedField = FieldHoc(InputOnChangeCommitted, "Slider");
